import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {PATHS} from 'Routes';
import {APP_PAGES} from 'utils/pages';
import {usePath, usePaymentsCart} from '../../hooks';
import navNext from '../../assets/icons/nav-next.svg';
import CustomIcon from '../common/CustomIcon';
import {
  NextArrow,
  PaymentAndOrdersActions,
  PaymentAndOrdersNumber,
  PaymentAndOrdersPanel,
  PaymentAndOrdersTitle,
} from './styled';

function PaymentsNavigationItem() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const {paymentsCart, isPaymentsCartFetching} = usePaymentsCart({refetchOnMount: false});

  return (
    <PaymentAndOrdersPanel
      isLoading={isPaymentsCartFetching}
      onClick={() =>
        navigate(getFullPath(PATHS.payments.main), {state: {from: APP_PAGES.summary}})
      }
      className="payment-nav-item"
    >
      <CustomIcon size={22} name={'creditCardBlue'} color="#2148FF" />
      <PaymentAndOrdersTitle className="payment-nav-item__title">
        {t('payment_and_orders')}
      </PaymentAndOrdersTitle>
      <PaymentAndOrdersActions className="payment-nav-item__actions">
        <PaymentAndOrdersNumber
          $blueMode={!!paymentsCart?.pay_now_payments?.length}
          className="payment-nav-item__counter"
        >
          {paymentsCart?.pay_now_payments?.length ?? 0}
        </PaymentAndOrdersNumber>
        <NextArrow src={navNext} />
      </PaymentAndOrdersActions>
    </PaymentAndOrdersPanel>
  );
}

export {PaymentsNavigationItem};
